import {
  DefaultConfigBuilderContext,
  PresentationType,
  SectionViewBuilderContext,
  SectionWidget,
} from "../section-widget";
import { AIAssistedTextSectionConfig } from "./ai-assisted-text-section-config";
import { AIAssistedTextSectionView } from "./ai-assisted-text-section-view";
import { filterXSS, IFilterXSSOptions } from "xss";
import { v4 as uuidv4 } from "uuid";

export const aiAssistedTextSectionFilterOptions: IFilterXSSOptions = {
  whiteList: {
    h1: ["style"],
    h2: ["style"],
    h3: ["style"],
    h4: ["style"],
    h5: ["style"],
    h6: ["style"],
    b: ["style"],
    p: ["style"],
    div: ["style"],
    strong: ["style"],
    em: ["style"],
    a: ["href", "target", "rel"],
    ul: ["style"],
    ol: ["style"],
    li: ["style"],
    br: [],
    i: ["style"],
    span: ["style"],
  },
};

export class AIAssistedTextSectionWidget
  implements
    SectionWidget<
      "ai-assisted-text",
      AIAssistedTextSectionConfig,
      AIAssistedTextSectionView
    >
{
  type = "ai-assisted-text" as const;

  supportedPresentationTypes: PresentationType[] = ["cma"];

  buildDefaultConfig(
    _: DefaultConfigBuilderContext
  ): AIAssistedTextSectionConfig {
    return {
      type: "ai-assisted-text",
      navTitle: "AI Assisted Text",
      id: uuidv4(),
      visibility: true,
      title: "Blank Section",
      htmlContent: `<h5 style="text-align:center;">Need help writing this section?</h5><p style="text-align:center;">Reply to Sidekick in the chat thread to generate custom copy for your CMA. Once you’re happy with the result, simply copy and paste it here.</p><p style="text-align:center;"><strong>Coming soon:</strong> You’ll be able to generate and edit copy directly in this section — no copying and pasting needed!</p>`,
    };
  }

  sanitizeSectionConfig(
    sectionConfig: AIAssistedTextSectionConfig
  ): AIAssistedTextSectionConfig {
    const { htmlContent } = sectionConfig;
    const sanitizedHtmlContent = filterXSS(
      htmlContent,
      aiAssistedTextSectionFilterOptions
    );
    return { ...sectionConfig, htmlContent: sanitizedHtmlContent };
  }

  buildView({
    sectionConfig: config,
  }: SectionViewBuilderContext<
    AIAssistedTextSectionConfig,
    null
  >): AIAssistedTextSectionView {
    if (config.type !== "ai-assisted-text")
      throw new Error("Unexpected section type.");
    const { id, type, visibility, htmlContent, title, navTitle } = config;
    const view: AIAssistedTextSectionView = {
      id,
      type,
      visibility,
      htmlContent,
      title,
      navTitle,
    };
    return view;
  }
}
